import { defineStore } from "pinia";
import { useApi } from "@/core/http";

const { get_data } = useApi();

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: sessionStorage.getItem('jwt') || null,
        isAuthenticated: !!sessionStorage.getItem('jwt'),
        message: '',
    }),
    actions: {
        setToken(newToken) {
            this.token = newToken;
            sessionStorage.setItem('jwt', newToken);
        },
        login(jwt, router) {
            this.setToken(jwt);
            this.isAuthenticated = true;
            router.push(sessionStorage.getItem('lastVisitedUrl') || '/dogs');
        },
        logout() {
            sessionStorage.removeItem('jwt');
            this.isAuthenticated = false;
            this.clearMessage();
        },
        async verify() {
            const token = sessionStorage.getItem('jwt');
            if(!token) {
                this.logout();
                return;
            }
            try {
                const response = await get_data(`/auth/login/verifyToken?token=${token}`);
                
                if (response && response.data.code !== 200) {
                    this.logout();
                    return;
                }
                this.isAuthenticated = response.data.query.token;
            } catch (error) {
                this.setMessage(error.message || error);
                throw new Error(this.message);
            }
        },
        async secretKey(uid) {
            try {
                const response = await get_data(`/auth/login/secretKey/${uid}`);
                if(response.data.code !== 200) {
                    throw new Error(response.data.message);
                }
                return response.data.query;
            } catch (error) {
                this.setMessage(error.message || error);
                throw new Error(this.message);
            }
        },
        setMessage(message) {
            this.message = message;
        },
        clearMessage() {
            this.message = '';
        }
    }
})